import { render, staticRenderFns } from "./Doctorlist.vue?vue&type=template&id=46e256ae&scoped=true&"
import script from "./Doctorlist.vue?vue&type=script&lang=js&"
export * from "./Doctorlist.vue?vue&type=script&lang=js&"
import style0 from "./Doctorlist.vue?vue&type=style&index=0&id=46e256ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e256ae",
  null
  
)

export default component.exports